(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drain-heat-scale"] && !Shopify.designMode) return;
  try {
    let drainHeatOpener = null;
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-drain-heat-open]');
  const dialog = document.getElementById('drain-heat-dialog');
  if (!dialog) return;
  if (trigger) {
    event.preventDefault();
    drainHeatOpener = trigger;
    const rating = Number(trigger.dataset.drainHeatOpen);
    dialog.querySelectorAll('.drain-heat-lineup li').forEach((item, index) => {
      item.classList.toggle('is-selected', index + 1 === rating);
    });
    if (!dialog.open) dialog.showModal();
    return;
  }
  if (event.target.closest('[data-drain-heat-close]')) dialog.close();
});
document.addEventListener('close', (event) => {
  if (event.target.id === 'drain-heat-dialog' && drainHeatOpener?.isConnected) drainHeatOpener.focus();
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drain-mobile-buy"] && !Shopify.designMode) return;
  try {
    (function(){
const bar=document.querySelector('.drain-mobile-buy'),main=document.getElementById('AddToCart'),title=document.querySelector('#ProductSection h1');
if(!bar||!main||!title)return;
const form=main.closest('form'),button=bar.querySelector('button'),label=button.querySelector('.drain-button-label'),price=document.getElementById('ProductPrice'),quantity=form.querySelector('[name="quantity"]'),variant=form.querySelector('[name="id"]');
const media=matchMedia('(max-width:749px)');
let mainVisible=false,busy=false;
function sync(){
 button.disabled=main.disabled||busy;
 label.textContent=main.querySelector('#AddToCartText')?.textContent.trim()||main.textContent.trim();
 bar.querySelector('.drain-mobile-buy__price').textContent=price?.textContent.trim()||'';
 const selected=form.querySelector('.variant-button.is-active');
 bar.querySelector('.drain-mobile-buy__variant').textContent=(selected?selected.textContent.trim()+' · ':'')+'QTY '+(quantity?.value||1);
}
function update(){
 const editing=/^(INPUT|SELECT|TEXTAREA)$/.test(document.activeElement?.tagName);
 const show=media.matches&&!mainVisible&&title.getBoundingClientRect().bottom<0&&!document.body.classList.contains('cart-drawer-open')&&!document.querySelector('dialog[open]')&&!editing;
 bar.hidden=!show;
 if(document.body.classList.contains('drain-mobile-buy-visible')!==show)document.body.classList.toggle('drain-mobile-buy-visible',show);
 if(show)document.body.style.setProperty('--drain-buy-height',bar.getBoundingClientRect().height+'px');
}
new IntersectionObserver(entries=>{mainVisible=entries[0].isIntersecting;update()}).observe(main);
new MutationObserver(()=>{sync();update()}).observe(main,{attributes:true,childList:true,subtree:true,characterData:true});
if(price)new MutationObserver(sync).observe(price,{childList:true,subtree:true,characterData:true});
new MutationObserver(update).observe(document.body,{attributes:true,attributeFilter:['class']});
document.querySelectorAll('dialog').forEach(d=>new MutationObserver(update).observe(d,{attributes:true,attributeFilter:['open']}));
form.addEventListener('change',sync);form.addEventListener('input',sync);
form.addEventListener('click',()=>requestAnimationFrame(sync));
window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);media.addEventListener('change',update);
document.addEventListener('focusin',update);document.addEventListener('focusout',()=>requestAnimationFrame(update));
button.addEventListener('click',()=>{
 if(main.disabled||busy)return;
 if(!form.reportValidity())return;
 busy=true;sync();main.click();
 setTimeout(()=>{busy=false;sync()},800);
});
sync();update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drain-product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
 const thumb = event.target.closest('[data-drain-media]');
 if (thumb) {
  const root=thumb.closest('#ProductSection');
  root.querySelectorAll('[data-drain-gallery] .product-single__media-item').forEach(item=>{
   const active=item.id==='ProductMediaDesktop-'+thumb.dataset.drainMedia;
   item.hidden=!active;
   if(!active) item.querySelectorAll('video').forEach(video=>video.pause());
  });
  root.querySelectorAll('[data-drain-media]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));
 }
 const step=event.target.closest('[data-drain-quantity]');
 if(step) {
  const input=step.parentElement.querySelector('input');
  const next=Math.max(Number(input.min)||1,(Number(input.value)||1)+Number(step.dataset.drainQuantity));
  input.value=String(next); input.dispatchEvent(new Event('change',{bubbles:true}));
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drain-shipping-orb"] && !Shopify.designMode) return;
  try {
    (function(){
const pod=document.getElementById('DrainShippingOrb');if(!pod)return;
const label=pod.querySelector('.drain-shipping-orb__message');
let timer,request=0;
const home=document.createComment('shipping-orb-home');pod.before(home);
function place(){
 const drawer=document.querySelector('[data-drain-orb-drawer]');
 const cart=document.querySelector('[data-drain-orb-cart]');
 const target=document.body.classList.contains('cart-drawer-open')?drawer:cart;
 if(target){if(pod.parentNode!==target)target.appendChild(pod)}
 else if(pod.previousSibling!==home){home.after(pod)}
}
new MutationObserver(place).observe(document.body,{attributes:true,attributeFilter:['class']});
place();
function render(total,currency){
 if(currency!=='USD'){pod.hidden=true;return}pod.hidden=false;
 const progress=Math.max(0,Math.min(1,Number(total)/6900));
 const left=Math.max(0,6900-Number(total));
 pod.style.setProperty('--orb-top',(96.3-progress*74.6)+'%');
 pod.dataset.full=String(left===0);
 const money=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:left%100?2:0,maximumFractionDigits:2}).format(left/100);
 const text=left>0?money+' TO FREE US SHIPPING':'FREE US SHIPPING UNLOCKED';
 if(label.textContent!==text)label.textContent=text;
}
async function refresh(){
 const id=++request;
 try{const res=await fetch(pod.dataset.cartUrl+'.js',{credentials:'same-origin',cache:'no-store'});if(!res.ok)return;const cart=await res.json();if(id===request)render(cart.total_price,cart.currency)}catch(e){}
}
function schedule(){clearTimeout(timer);timer=setTimeout(refresh,120)}
render(Number(pod.dataset.total),pod.dataset.currency);
document.addEventListener('cart:updated',schedule);
document.addEventListener('cart:item-added',schedule);
window.addEventListener('pageshow',schedule);
window.addEventListener('focus',schedule);
document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule()});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    (() => {
  let activeCard = null;
  let activeTouch = null;
  const resetPreview = () => {
    activeCard?.classList.remove('is-touch-preview');
    activeCard = null;
    activeTouch = null;
  };
  document.addEventListener('touchstart', (event) => {
    if (activeCard) return;
    const link = event.target.closest('.product__link');
    const card = link?.closest('.product--has-hover-image');
    const touch = event.changedTouches[0];
    if (!card || !touch) return;
    card.setAttribute('data-touch-preview', '');
    activeCard = card;
    activeTouch = touch.identifier;
    card.classList.add('is-touch-preview');
  }, { passive: true });
  const finishTouch = (event) => {
    if (Array.from(event.changedTouches).some(touch => touch.identifier === activeTouch)) resetPreview();
  };
  document.addEventListener('touchend', finishTouch, { passive: true });
  document.addEventListener('touchcancel', finishTouch, { passive: true });
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    event.target.closest('.product--has-hover-image')?.removeAttribute('data-touch-preview');
  }, { passive: true });
  document.addEventListener('visibilitychange', resetPreview);
  document.addEventListener('shopify:section:unload', resetPreview);
  window.addEventListener('blur', resetPreview);
  window.addEventListener('pagehide', resetPreview);
  window.addEventListener('pageshow', resetPreview);
})();
  } catch(e) { console.error(e); }
})();

})();
